import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { registerLocaleData } from "@angular/common";
import localeIn from "@angular/common/locales/en-IN";
import { environment } from "./environments/environment";

// Register the Indian locale
registerLocaleData(localeIn, "en-IN");

console.log = () => { };
console.debug = () => { };
console.info = () => { };
console.warn = () => { };
console.error = () => { };
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);

if (environment.production) {
  const gaId = "G-C2B0YW0BNV";
  const adsId = 'AW-704132559';
  // Load GA script
  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script1);

  // Initialize GA
  const script2 = document.createElement("script");
  script2.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${gaId}');
    gtag('config', '${adsId}');
  `;
  document.head.appendChild(script2);
}
